<app-container-standard title="Company Report">
    <form #f="ngForm" (ngSubmit)="onSubmit(f.value)">
        <div class="form-row">


            <div class="form-group col-md-4">
                <mat-form-field class="example-full-width">
                    <mat-label>Focus</mat-label>
                    <mat-select [(value)]="focus">
                        <mat-option (click)="changeFocus('ALL')" value="ALL">
                            All
                        </mat-option>
                        <mat-option (click)="changeFocus('BYPRODUCT')" value="BYPRODUCT">
                            Product
                        </mat-option>
                        <!-- <mat-option  (click)="changeFocus('BYEMPLOYEE')" value="BYEMPLOYEE">
                            Employee
                          </mat-option> -->
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="form-group col-md-4">
                <mat-form-field>
                    <mat-select placeholder="Select time period" [(value)]="timeSelected"
                        (selectionChange)="setTimePeriodeEvent($event)">
                        <mat-option value="TODAY" selected>Today</mat-option>
                        <mat-option value="YESTERDAY">Yesterday</mat-option>
                        <mat-option value="24H">Last 24 hours</mat-option>
                        <!-- <mat-option value="THIS_WEEK">This week</mat-option>
                        <mat-option value="LAST_WEEK">Last week</mat-option> -->
                        <mat-option value="THIS_MONTH">This month</mat-option>
                        <mat-option value="LAST_MONTH">Last month</mat-option>
                        <mat-option value="CUSTOM">Customized</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

        </div>
        <!-- timeSelected == 'CUSTOM' -->
        <ng-container *ngIf="timeSelected == 'CUSTOM'">
            <mat-label>Custom time periode:</mat-label><br>
            <div class="form-row" *ngIf="inputDateFrom">
                <!-- <angular2-date-picker [(ngModel)]="inputDateFrom" name="fromDatePricker" [settings]="settings"></angular2-date-picker> -->
                <!-- 
                <div class="form-group col-md-4">
                    <span class="datetime-picker-label">Date from</span><br>
                    <input class="datetime-picker" [(ngModel)]="inputDateFrom" name="dataFrom" [owlDateTime]="dt2" placeholder="Date Time">
                    <span [owlDateTimeTrigger]="dt2" class="date-icon"><i class="fa fa-calendar"></i></span>
                    <owl-date-time firstDayOfWeek="1" #dt2></owl-date-time>
                </div>
                <div class="form-group col-md-4">
                        <span class="datetime-picker-label">Date to</span><br>
                        <input class="datetime-picker" [(ngModel)]="inputDateTo" name="dateTo" [owlDateTime]="dt3" placeholder="Date Time">
                        <span [owlDateTimeTrigger]="dt3" class="date-icon"><i class="fa fa-calendar"></i></span>
                        <owl-date-time firstDayOfWeek="1" #dt3></owl-date-time>
                    </div> -->

                <!-- <div class="form-group col-md-4">


                    <mat-form-field>
                        <input matInput type="datetime-local" [matDatepicker]="dateFrom" name="inputDateFrom"
                             placeholder="Date From">
                        <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                        <mat-datepicker #dateFrom></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="form-group col-md-4">
                    <mat-form-field>
                        <input matInput [matDatepicker]="dateTo" name="dateTo" ngModel placeholder="Date To">
                        <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                        <mat-datepicker #dateTo></mat-datepicker>
                    </mat-form-field>
                </div> -->
                <div class="form-group col-md-4">
                    <ng-container *ngIf="timeSelected == 'CUSTOM'">
                        <mat-form-field>
                            <mat-label>Custom Date Range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate placeholder="Start date"
                                    (dateChange)="setCustomRange($event, 'start')">
                                <input matEndDate placeholder="End date" (dateChange)="setCustomRange($event, 'end')">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>

                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <input type="time"  name='startTime' (change)="setToTime()"  id="startTime" >
                            </div>

                            <div class="form-group col-md-4">
                                <input type="time"  name='endTime' (change)="setEndTime()"  id="endTime" >
                            </div>

                        </div>
                    </ng-container>


                </div>
            </div>
            <!-- <button type="button" (click)="setToTime()" class="theme-primary white-text float-right" mat-flat-button>Create</button> -->

        </ng-container>
        <div class="example-button-row">
            <button type="button" class="theme-gray gray-text" style="visibility: hidden;" mat-flat-button
                (click)="onReset(f)">Reset</button>
            <button type="submit" class="theme-primary white-text float-right" mat-flat-button>Create</button>
        </div>
    </form>
</app-container-standard>
<router-outlet></router-outlet>